/* Small progressive enhancements for the catalogue theme. */
(() => {
  const nav = document.querySelector('nav.main');
  const toggle = nav?.querySelector('.nav-toggle');
  const setMenu = (open) => {
    nav?.classList.toggle('is-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
  };
  toggle?.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  nav?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      toggle.focus();
    }
  });
  nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  const desktop = window.matchMedia('(min-width: 981px)');
  desktop.addEventListener('change', () => setMenu(false));
  // The menu stays available when JavaScript is disabled.
  nav?.classList.add('is-enhanced');

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.gallery-main');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-src]').forEach((button) => {
      button.addEventListener('click', () => {
        main.src = button.dataset.gallerySrc;
        main.alt = button.dataset.galleryAlt || '';
        gallery.querySelectorAll('[data-gallery-src]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });

  const product = new URLSearchParams(window.location.search).get('product');
  const message = document.getElementById('cf-body');
  if (product && message && !message.value) message.value = `Hi, I'd like to ask about: ${product}\n\n`;
})();
